import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({     
  container: {
    flex: 2,
    backgroundColor: 'white',
    borderRadius: 12,
    overflow: 'hidden',
    // Ombres pour iOS et Web
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    // Elevation pour Android
    elevation: 3,
    borderWidth: 1,
    borderColor: '#e2e8f0',
  },
  
  infoPlaceholder: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f8fafc',
    padding: 40,
  },
  
  infoPlaceholderText: {
    marginTop: 12, fontSize: 18, fontWeight: '600', color: '#384454', textAlign: 'center' 
  },
})

export default styles
